import React, { Component } from 'react';
import { connect } from 'react-redux';

import { LoadingBar, StatTable } from 'components/Commons';
import cm from 'helpers/commons';

class SikdaeGroupStatsResult extends Component {
  render() {
    const { groupStats } = this.props;

    let tabledata;
    if (groupStats) {
      if (groupStats.data) {
        const { stat } = groupStats.data;
        tabledata =
          stat && stat.length > 0
            ? stat.map((item) => {
                const { group } = item,
                  depth1 = group.policy.map((item1) => {
                    let obj = {
                      row: [
                        { content: '-', fontColor: '#FFFFFF', textAlign: 'left' },
                        { content: item1.name, textAlign: 'left' },
                        { content: item1.type.text, textAlign: 'left' },
                        { content: cm.numberComma(item1.amount), textAlign: 'right' },
                        { content: cm.numberComma(item1.useamount), textAlign: 'right' }
                      ]
                    };
                    return obj;
                  });

                let obj = {
                  header: [
                    { content: group.name, textAlign: 'left' },
                    { content: '' },
                    { content: '' },
                    { content: '' },
                    { content: cm.numberComma(group.useamount), textAlign: 'right' }
                  ],
                  body: depth1
                };
                return obj;
              })
            : '식대 그룹 통계 내역이 없습니다.';
      } else if (groupStats.response) {
        tabledata = groupStats.response.data.message;
      }
    } else {
      tabledata = '식대 그룹 통계 내역이 없습니다.';
    }

    let loading = '';
    if (!tabledata) {
      loading = <LoadingBar />;
    }

    return (
      <div className="group-stat-result table-container">
        {loading}

        <div className="table-box">
          <StatTable
            colWidth={[220, 170, 170, 170, 170]}
            header={[
              { content: '식대그룹', textAlign: 'left' },
              { content: '정책', textAlign: 'left' },
              { content: '종류', textAlign: 'left' },
              { content: '지급식대', textAlign: 'right' },
              { content: '회사식대', textAlign: 'right' }
            ]}
            data={tabledata}
          />
        </div>
      </div>
    );
  }
}

SikdaeGroupStatsResult = connect((state) => ({
  groupStats: state.usage.groupStats
}))(SikdaeGroupStatsResult);

export default SikdaeGroupStatsResult;
